// import React, { useState, useEffect } from "react";
// import { Container, Row, Card, CardBody, Badge } from "reactstrap";
// import { useParams, useNavigate } from "react-router-dom";
// import Breadcrumbs from "../../../components/Common/Breadcrumb";
// import Loader from "pages/Separate/Loader";
// import moment from "moment";
// // import { axiosNodeInstance } from "utils/config";

// /**
//  * ContractAmendmentHistory
//  * Route: /sales/contract-amendments/:id
//  *
//  * Fetches all amendments for a contract and renders:
//  *  - Live contract summary cards
//  *  - "All versions" tab — version cards with expandable detail
//  *  - "Audit trail" tab   — full timeline of every action
//  */

// /* ─────────────── mock data (remove once API is wired) ─────────────── */
// const MOCK = {
//   contract: {
//     id: 1042,
//     company_name: "Acme Corp",
//     type: "Website Development",
//     original_value: 10000,
//     live_value: 12000,
//     currency_symbol: "£",
//     original_hours: 100,
//     live_hours: 120,
//     original_end_date: "2024-12-31",
//     live_end_date: "2025-01-31",
//     assigned_name: "Sarah Thompson",
//     startdate: "2024-09-01",
//   },
//   versions: [
//     {
//       id: "v1",
//       version_label: "Version 1",
//       title: "Original contract",
//       status: "original",
//       value: 10000,
//       hours: 100,
//       end_date: "2024-12-31",
//       created_by: "Sarah Thompson",
//       created_at: "2024-09-01",
//       approved_by: null,
//       approved_at: null,
//       details: {
//         contract_type: "Website Development",
//         related: "Lead · Acme Corp",
//         contact_person: "James Whitfield",
//         payment_schedule: "50% on start · 50% on delivery",
//         scope_items: ["Homepage redesign", "CMS integration", "SEO setup"],
//       },
//       changes: [],
//     },
//     {
//       id: "v2",
//       version_label: "Amendment 1",
//       title: "Additional dev scope",
//       status: "approved",
//       value: 12000,
//       hours: 120,
//       end_date: "2025-01-31",
//       created_by: "Sarah Thompson",
//       created_at: "2024-11-08",
//       approved_by: "James Whitfield",
//       approved_at: "2024-11-18",
//       description:
//         "Client requested addition of e-commerce checkout module and product listing pages post contract sign-off.",
//       change_reason: "Client requested additional scope",
//       effective_date: "2024-11-15",
//       details: {
//         effective_date: "15 Nov 2024",
//         scope_additions: ["E-commerce checkout module", "Product listing pages"],
//         scope_removals: [],
//         milestone_changes: ["Final delivery: 31 Dec 2024 → 31 Jan 2025"],
//         document_sent: "10 Nov 2024 · via email",
//       },
//       changes: [
//         { type: "fee_add", label: "+£2,000 fee" },
//         { type: "hours_add", label: "+20 hrs" },
//         { type: "date", label: "Deadline → 31 Jan 2025" },
//         { type: "scope_add", label: "E-commerce module added" },
//       ],
//     },
//     {
//       id: "v3",
//       version_label: "Amendment 2",
//       title: "Resource allocation change",
//       status: "pending",
//       value: 12000,
//       hours: 130,
//       end_date: "2025-01-31",
//       created_by: "Raj Patel",
//       created_at: "2025-01-05",
//       approved_by: null,
//       approved_at: null,
//       description: "Resource reallocation — content migration moved in-house by client.",
//       change_reason: "Resource change",
//       effective_date: "2025-01-10",
//       details: {
//         effective_date: "10 Jan 2025",
//         scope_additions: [],
//         scope_removals: ["Content migration (client will handle in-house)"],
//         milestone_changes: ["QA sign-off: 31 Jan 2025 → 20 Feb 2025"],
//         document_sent: "06 Jan 2025 · via email",
//       },
//       changes: [
//         { type: "hours_add", label: "+10 hrs" },
//         { type: "date", label: "QA milestone → 20 Feb 2025" },
//         { type: "scope_remove", label: "Content migration removed" },
//       ],
//     },
//   ],
//   audit_trail: [
//     {
//       id: 6,
//       action: "Amendment 2 sent for signature",
//       actor: "Raj Patel",
//       timestamp: "2025-01-06T10:42:00",
//       dot: "pending",
//     },
//     {
//       id: 5,
//       action: "Amendment 2 created",
//       actor: "Raj Patel",
//       timestamp: "2025-01-05T15:17:00",
//       dot: "pending",
//     },
//     {
//       id: 4,
//       action: "Live contract auto-updated — value £10,000→£12,000 · hours 100→120 · deadline extended",
//       actor: "System",
//       timestamp: "2024-11-18T14:05:00",
//       dot: "success",
//     },
//     {
//       id: 3,
//       action: "Amendment 1 approved & signed",
//       actor: "James Whitfield (client)",
//       timestamp: "2024-11-18T14:05:00",
//       dot: "success",
//     },
//     {
//       id: 2,
//       action: "Amendment 1 sent for signature",
//       actor: "Sarah Thompson",
//       timestamp: "2024-11-10T11:30:00",
//       dot: "success",
//     },
//     {
//       id: 1,
//       action: "Amendment 1 created",
//       actor: "Sarah Thompson",
//       timestamp: "2024-11-08T16:55:00",
//       dot: "success",
//     },
//     {
//       id: 0,
//       action: "Original contract signed",
//       actor: "James Whitfield (client)",
//       timestamp: "2024-09-02T09:00:00",
//       dot: "primary",
//     },
//     {
//       id: -1,
//       action: "Contract created (Version 1)",
//       actor: "Sarah Thompson",
//       timestamp: "2024-09-01T10:15:00",
//       dot: "primary",
//     },
//   ],
// };
// /* ─────────────────────────────────────────────────────────────────── */

// const STATUS_CONFIG = {
//   original: { label: "Original", className: "bg-primary" },
//   approved: { label: "Approved", className: "bg-success" },
//   pending: { label: "Pending approval", className: "bg-warning" },
//   draft: { label: "Draft", className: "bg-secondary" },
// };

// // const CHANGE_CHIP = {
// //   fee_add: { bg: "rgba(52,195,143,0.12)", color: "#34c38f", icon: "fas fa-plus" },
// //   fee_remove: { bg: "rgba(244,106,106,0.12)", color: "#f46a6a", icon: "fas fa-minus" },
// //   hours_add: { bg: "rgba(52,195,143,0.12)", color: "#34c38f", icon: "fas fa-plus" },
// //   hours_remove: { bg: "rgba(244,106,106,0.12)", color: "#f46a6a", icon: "fas fa-minus" },
// //   date: { bg: "rgba(85,110,230,0.1)", color: "#556ee6", icon: "fas fa-calendar-alt" },
// //   scope_add: { bg: "rgba(52,195,143,0.12)", color: "#34c38f", icon: "fas fa-check" },
// //   scope_remove: { bg: "rgba(244,106,106,0.12)", color: "#f46a6a", icon: "fas fa-times" },
// // };

// const CHANGE_CHIP = {
//   fee_add: {
//     bg: "#f0e6f6",
//     border: "#d8bfe8",
//     color: "#330148",
//     icon: "fas fa-plus",
//   },
//   fee_remove: {
//     bg: "#f0e6f6",
//     border: "#d8bfe8",
//     color: "#330148",
//     icon: "fas fa-minus",
//   },
//   hours_add: {
//     bg: "#f0e6f6",
//     border: "#d8bfe8",
//     color: "#330148",
//     icon: "fas fa-clock",
//   },
//   hours_remove: {
//     bg: "#f0e6f6",
//     border: "#d8bfe8",
//     color: "#330148",
//     icon: "fas fa-clock",
//   },
//   date: {
//     bg: "#f0e6f6",
//     border: "#d8bfe8",
//     color: "#330148",
//     icon: "fas fa-calendar-alt",
//   },
//   scope_add: {
//     bg: "#f0e6f6",
//     border: "#d8bfe8",
//     color: "#330148",
//     icon: "fas fa-check",
//   },
//   scope_remove: {
//     bg: "#f0e6f6",
//     border: "#d8bfe8",
//     color: "#330148",
//     icon: "fas fa-times",
//   },
// };

// const DOT_COLORS = {
//   primary: "#556ee6",
//   success: "#34c38f",
//   pending: "#f1b44c",
// };

// const ContractAmendmentHistory = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [isLoading, setLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("versions");
//   const [expanded, setExpanded] = useState({});
//   const [contractData, setContractData] = useState(null);
//   const [versions, setVersions] = useState([]);
//   const [auditTrail, setAuditTrail] = useState([]);

//   document.title = "Amendment History | Zithas CRM";

//   useEffect(() => {
//     fetchAmendments();
//   }, [id]);

//   const fetchAmendments = async () => {
//     setLoading(true);
//     try {
//       // Replace with real API:
//       // const res = await axiosNodeInstance.get(`/contract/amendments/${id}`);
//       // setContractData(res.data.contract);
//       // setVersions(res.data.versions);
//       // setAuditTrail(res.data.audit_trail);

//       await new Promise((r) => setTimeout(r, 500));
//       setContractData(MOCK.contract);
//       setVersions(MOCK.versions);
//       setAuditTrail(MOCK.audit_trail);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleExpand = (versionId) =>
//     setExpanded((prev) => ({ ...prev, [versionId]: !prev[versionId] }));

//   const sym = contractData?.currency_symbol || "£";
//   const amendmentCount = versions.filter((v) => v.id !== "v1").length;
//   const pendingCount = versions.filter((v) => v.status === "pending").length;
//   const approvedCount = versions.filter((v) => v.status === "approved").length;

//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="page-content">
//         <Container fluid>
//           <Breadcrumbs title="Sales" breadcrumbItem="Amendment History" />

//           {contractData && (
//             <>
//               {/* ── Page header ── */}
//               <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
//                 <div>
//                   <h5 className="mb-1 d-flex align-items-center gap-2">
//                     <i className="fas fa-history text-purple"></i>
//                     {contractData.company_name} — Amendment history
//                   </h5>
//                   <span style={{ fontSize: "12px", color: "#74788d" }}>
//                     Contract #{contractData.id} · {contractData.type}
//                   </span>
//                 </div>
//                 <button
//                   //className="btn btn-sm btn-outline-secondary btn-label"
//                   className="btn btn-danger btn-label"
//                   onClick={() => navigate(-1)}
//                 >
//                   <i className="dripicons-arrow-thin-left label-icon icon-center"></i>
//                   Cancel
//                 </button>
//               </div>

//               {/* ── Summary metrics ── */}
//               {/* <Row className="mb-3 g-2">
//                 <MetricCard
//                   label="Live contract value"
//                   value={`${sym}${contractData.live_value?.toLocaleString()}`}
//                   sub={`Original: ${sym}${contractData.original_value?.toLocaleString()}`}
//                   subColor={contractData.live_value > contractData.original_value ? "#34c38f" : "#74788d"}
//                   icon="fas fa-pound-sign"
//                 />
//                 <MetricCard
//                   label="Total hours"
//                   value={`${contractData.live_hours} hrs`}
//                   sub={`Original: ${contractData.original_hours} hrs`}
//                   subColor={contractData.live_hours > contractData.original_hours ? "#34c38f" : "#74788d"}
//                   icon="fas fa-clock"
//                 />
//                 <MetricCard
//                   label="Completion date"
//                   value={moment(contractData.live_end_date).format("DD MMM YYYY")}
//                   sub={`Original: ${moment(contractData.original_end_date).format("DD MMM YYYY")}`}
//                   subColor="#74788d"
//                   icon="fas fa-calendar-check"
//                 />
//                 <MetricCard
//                   label="Amendments"
//                   value={amendmentCount}
//                   sub={`${approvedCount} approved · ${pendingCount} pending`}
//                   subColor="#74788d"
//                   icon="fas fa-file-alt"
//                 />
//               </Row> */}

//               {/* ── Tabs ── */}
//               <Card>
//                 <CardBody className="p-0">
//                   {/* Tab nav */}
//                   <div
//                     className="d-flex border-bottom"
//                     style={{ padding: "0 16px" }}
//                   >
//                     <TabButton
//                       active={activeTab === "versions"}
//                       onClick={() => setActiveTab("versions")}
//                       icon="fas fa-layer-group"
//                     >
//                       All versions
//                     </TabButton>
//                     <TabButton
//                       active={activeTab === "audit"}
//                       onClick={() => setActiveTab("audit")}
//                       icon="fas fa-list-ul"
//                     >
//                       Audit trail
//                     </TabButton>
//                   </div>

//                   <div className="p-3">
//                     {/* ── All versions tab ── */}
//                     {activeTab === "versions" && (
//                       <div>
//                         {versions.map((version) => {
//                           const cfg = STATUS_CONFIG[version.status] || STATUS_CONFIG.draft;
//                           const isOpen = expanded[version.id];

//                           return (
//                             // <div
//                             //   key={version.id}
//                             //   className="mb-3 rounded"
//                             //   style={{
//                             //     border: "1px solid #eff2f7",
//                             //     overflow: "hidden",
//                             //   }}
//                             // >
//                             <div
//   key={version.id}
//   className="mb-4 rounded"
//   style={{
//     border: "1px solid #d6dbe3",
//     // borderLeft:
//     //   version.status === "approved"
//     //     ? "4px solid #495057"
//     //     : version.status === "pending"
//     //     ? "4px solid #f1b44c"
//     //     : "4px solid #6c757d",
//     borderLeft: "1px solid #d6dbe3",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
//     overflow: "hidden",
//     background: "#fff",
//   }}
// >
//                               {/* Version card header */}
//                               <div
//                                 className="d-flex align-items-center justify-content-between px-3 py-2"
//                                 style={{
//                                   background: "#f8f9fa",
//                                   borderBottom: "1px solid #eff2f7",
//                                 }}
//                               >
//                                 <div className="d-flex align-items-center gap-2">
//                                   {/* <i
//                                     className={`${
//                                       version.status === "original"
//                                         ? "fas fa-file-contract"// text-primary"
//                                         : "fas fa-file-signature"// text-success"
//                                     }`}
//                                     style={{ fontSize: "14px" }}
//                                   ></i> */}
//                                   {/* <span
//                                     style={{
//                                       fontWeight: 500,
//                                       fontSize: "13px",
//                                       color: "#495057",
//                                     }}
//                                   >
//                                     {version.version_label}
//                                     <span
//                                       className="ms-2 fw-normal text-muted"
//                                       style={{ fontSize: "12px" }}
//                                     >
//                                       — {version.title}
//                                     </span>
//                                   </span> */}
//                                   <span
//   className="badge me-2"
//   style={{
//     fontSize: "10px",
//     padding: "5px 8px",
//     background: "#6a2a8d",
//   }}
// >
//   {version.version_label}
// </span>
// {version.title}
//                                 </div>
//                                 <div className="d-flex align-items-center gap-2">
//                                   <Badge className={cfg.className} style={{ fontSize: "11px" }}>
//                                     {cfg.label}
//                                   </Badge>
//                                   <button
//                                     className="btn btn-sm btn-outline-secondary"
//                                     style={{ fontSize: "11px", padding: "3px 10px" }}
//                                     onClick={() => {}} /* wire to view PDF / modal */
//                                   >
//                                     <i className="fas fa-eye me-1"></i> View
//                                   </button>
//                                 </div>
//                               </div>

//                               {/* Version body */}
//                               <div className="p-3">
//                                 {/* Change chips */}
//                                 {version.changes?.length > 0 && (
//                                   <div className="d-flex flex-wrap gap-1 mb-3">
//                                     {version.changes.map((ch, i) => {
//                                       const chip = CHANGE_CHIP[ch.type] || CHANGE_CHIP.date;
//                                       return (
//                                         <span
//                                           key={i}
//                                           className="d-inline-flex align-items-center gap-1"
//                                           style={{
//                                             background: chip.bg,
//                                             color: chip.color,
//                                             fontSize: "11px",
//                                             padding: "3px 10px",
//                                             borderRadius: "50px",
//                                             fontWeight: 500,
//                                           }}
//                                         >
//                                           <i className={chip.icon} style={{ fontSize: "10px" }}></i>
//                                           {ch.label}
//                                         </span>
//                                       );
//                                     })}
//                                   </div>
//                                 )}

//                                 {/* Key values grid */}
//                                 <div
//                                   className="d-flex flex-wrap gap-3 mb-2"
//                                   style={{ fontSize: "13px" }}
//                                 >
//                                   <KVPair label="Value" value={`${sym}${version.value?.toLocaleString()}`} />
//                                   <KVPair label="Hours" value={`${version.hours} hrs`} />
//                                   <KVPair
//                                     label="Completion"
//                                     value={moment(version.end_date).format("DD MMM YYYY")}
//                                   />
//                                 </div>

//                                 {version.description && (
//                                   <div
//                                     className="mb-2 p-2 rounded"
//                                     style={{
//                                       background: "#f8f9fa",
//                                       fontSize: "12px",
//                                       color: "#74788d",
//                                       borderLeft: "3px solid #eff2f7",
//                                     }}
//                                   >
//                                     {version.description}
//                                   </div>
//                                 )}

//                                 {/* Audit line */}
//                                 <div
//                                   className="d-flex align-items-center justify-content-between flex-wrap gap-2 pt-2"
//                                   style={{
//                                     borderTop: "1px solid #eff2f7",
//                                     fontSize: "11px",
//                                     color: "#74788d",
//                                   }}
//                                 >
//                                   <span>
//                                     <i className="fas fa-user-edit me-1"></i>
//                                     Created by <strong>{version.created_by}</strong> ·{" "}
//                                     {moment(version.created_at).format("DD MMM YYYY")}
//                                   </span>
//                                   {version.approved_by && (
//                                     <span>
//                                       <span style={{ color: "#34c38f" }}><i className="fas fa-check-circle me-1"></i>
//                                       Approved</span> by <strong>{version.approved_by}</strong> ·{" "}
//                                       {moment(version.approved_at).format("DD MMM YYYY")}
//                                     </span>
//                                   )}
//                                   {version.status === "pending" && (
//                                     <span style={{ color: "#f1b44c" }}>
//                                       <i className="fas fa-clock me-1"></i>
//                                       Awaiting client signature
//                                     </span>
//                                   )}
//                                   <button
//                                     className="btn btn-link p-0 text-decoration-none"
//                                     style={{ fontSize: "11px", color: "#556ee6" }}
//                                     onClick={() => toggleExpand(version.id)}
//                                   >
//                                     <i
//                                       className={`fas ${isOpen ? "fa-chevron-up" : "fa-chevron-down"} me-1`}
//                                     ></i>
//                                     {isOpen ? "Hide details" : "Show details"}
//                                   </button>
//                                 </div>

//                                 {/* Expandable detail panel */}
//                                 {isOpen && (
//                                   <div
//                                     className="mt-2 p-3 rounded"
//                                     style={{
//                                       background: "#f8f9fa",
//                                       border: "1px solid #eff2f7",
//                                       fontSize: "12px",
//                                     }}
//                                   >
//                                     <DetailGrid details={version.details} />
//                                   </div>
//                                 )}
//                               </div>
//                             </div>
//                           );
//                         })}
//                       </div>
//                     )}

//                     {/* ── Audit trail tab ── */}
//                     {activeTab === "audit" && (
//                       <div style={{ position: "relative", paddingLeft: "28px" }}>
//                         {/* Vertical line */}
//                         <div
//                           style={{
//                             position: "absolute",
//                             left: "9px",
//                             top: "6px",
//                             bottom: "6px",
//                             width: "1px",
//                             background: "#eff2f7",
//                           }}
//                         />

//                         {auditTrail.map((item) => (
//                           <div
//                             key={item.id}
//                             className="mb-3"
//                             style={{ position: "relative" }}
//                           >
//                             {/* Dot */}
//                             <div
//                               style={{
//                                 position: "absolute",
//                                 left: "-22px",
//                                 top: "4px",
//                                 width: "11px",
//                                 height: "11px",
//                                 borderRadius: "50%",
//                                 background: DOT_COLORS[item.dot] || "#eff2f7",
//                                 border: `2px solid ${DOT_COLORS[item.dot] || "#ced4da"}`,
//                               }}
//                             />
//                             <div style={{ fontSize: "13px" }}>
//                               <span style={{ fontWeight: 500, color: "#495057" }}>
//                                 {item.action}
//                               </span>
//                               <div style={{ fontSize: "11px", color: "#74788d", marginTop: "2px" }}>
//                                 <i className="fas fa-user me-1"></i>
//                                 {item.actor}
//                                 <span className="mx-2">·</span>
//                                 <i className="fas fa-clock me-1"></i>
//                                 {moment(item.timestamp).format("DD MMM YYYY · hh:mm A")}
//                               </div>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 </CardBody>
//               </Card>
//             </>
//           )}
//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };

// /* ── Sub-components ── */

// const MetricCard = ({ label, value, sub, subColor, icon }) => (
//   <div className="col-md-3 col-sm-6">
//     <div
//       className="p-3 rounded d-flex align-items-center gap-3"
//       style={{
//         background: "#fff",
//         border: "1px solid #eff2f7",
//         height: "100%",
//       }}
//     >
//       <div
//         className="rounded d-flex align-items-center justify-content-center flex-shrink-0"
//         style={{
//           width: "40px",
//           height: "40px",
//           background: "rgba(85,110,230,0.1)",
//         }}
//       >
//         <i className={`${icon}`} style={{ color: "#556ee6", fontSize: "16px" }}></i>
//       </div>
//       <div>
//         <div style={{ fontSize: "11px", color: "#74788d", marginBottom: "2px" }}>{label}</div>
//         <div style={{ fontSize: "18px", fontWeight: 600, color: "#343a40", lineHeight: 1.2 }}>
//           {value}
//         </div>
//         <div style={{ fontSize: "11px", color: subColor, marginTop: "2px" }}>{sub}</div>
//       </div>
//     </div>
//   </div>
// );

// const TabButton = ({ active, onClick, icon, children }) => (
//   <button
//     type="button"
//     onClick={onClick}
//     style={{
//       background: "none",
//       border: "none",
//       borderBottom: active ? "2px solid #556ee6" : "2px solid transparent",
//       color: active ? "#556ee6" : "#74788d",
//       fontWeight: active ? 500 : 400,
//       fontSize: "13px",
//       padding: "12px 16px",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       gap: "6px",
//       marginBottom: "-1px",
//     }}
//   >
//     <i className={icon} style={{ fontSize: "13px" }}></i>
//     {children}
//   </button>
// );

// const KVPair = ({ label, value }) => (
//   <span style={{ fontSize: "13px" }}>
//     <span style={{ color: "#74788d", marginRight: "4px" }}>{label}:</span>
//     <strong style={{ color: "#343a40" }}>{value}</strong>
//   </span>
// );

// const DetailGrid = ({ details }) => {
//   if (!details) return null;
//   return (
//     <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
//       <tbody>
//         {Object.entries(details).map(([key, val]) => {
//           const label = key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
//           const display = Array.isArray(val)
//             ? val.length
//               ? val.join(", ")
//               : "None"
//             : val || "—";
//           return (
//             <tr key={key}>
//               <td
//                 style={{
//                   padding: "4px 8px 4px 0",
//                   color: "#74788d",
//                   width: "160px",
//                   verticalAlign: "top",
//                   fontWeight: 500,
//                 }}
//               >
//                 {label}
//               </td>
//               <td style={{ padding: "4px 0", color: "#495057" }}>{display}</td>
//             </tr>
//           );
//         })}
//       </tbody>
//     </table>
//   );
// };

// export default ContractAmendmentHistory;



/**dynamic */
import React, { useState, useEffect } from "react";
import { Container, Row, Card, CardBody, Badge } from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Loader from "pages/Separate/Loader";
import moment from "moment";
import axios from "axios";
import configure from "configure";
import Swal from "sweetalert2";

const STATUS_CONFIG = {
  original: { label: "Original", className: "bg-primary" },
  approved: { label: "Approved", className: "bg-success" },
  pending: { label: "Pending approval", className: "bg-warning" },
  rejected: { label: "Rejected", className: "bg-danger" },
  draft: { label: "Draft", className: "bg-secondary" },
};

const CHANGE_CHIP = {
  fee_add: { bg: "#f0e6f6", border: "#d8bfe8", color: "#330148", icon: "fas fa-plus" },
  fee_remove: { bg: "#f0e6f6", border: "#d8bfe8", color: "#330148", icon: "fas fa-minus" },
  hours_add: { bg: "#f0e6f6", border: "#d8bfe8", color: "#330148", icon: "fas fa-clock" },
  hours_remove: { bg: "#f0e6f6", border: "#d8bfe8", color: "#330148", icon: "fas fa-clock" },
  date: { bg: "#f0e6f6", border: "#d8bfe8", color: "#330148", icon: "fas fa-calendar-alt" },
  scope_add: { bg: "#f0e6f6", border: "#d8bfe8", color: "#330148", icon: "fas fa-check" },
  scope_remove: { bg: "#f0e6f6", border: "#d8bfe8", color: "#330148", icon: "fas fa-times" },
};

const DOT_COLORS = { primary: "#556ee6", success: "#34c38f", pending: "#f1b44c", danger: "#f46a6a" };

const parseScope = (scopeStr) =>
  scopeStr ? scopeStr.split("@#").filter(Boolean) : [];

// const parseScopeItems = (raw) => {
//   try {
//     return typeof raw === "string" ? JSON.parse(raw) : raw || [];
//   } catch (e) {
//     return [];
//   }
// };
const parseScopeItems = (raw) => {
  let val = raw;
  // unwrap up to 3 levels of JSON-stringification defensively
  for (let i = 0; i < 3; i++) {
    if (Array.isArray(val)) return val;
    if (typeof val !== "string") break;
    try {
      val = JSON.parse(val);
    } catch (e) {
      break;
    }
  }
  return Array.isArray(val) ? val : [];
};

/* ── Transform raw API payload into the version-card list the UI renders ── */
const buildVersionsList = (contract, versions, amendments, sym) => {
  const versionsByNo = {};
  versions.forEach((v) => (versionsByNo[v.version_no] = v));

  const list = [];
  const v1 = versionsByNo[1];

  // Version 1 — original contract
  if (v1) {
    list.push({
      id: "v1",
      version_label: "Version 1",
      title: "Original contract",
      status: "original",
      value: parseFloat(v1.value) || 0,
      hours: parseFloat(v1.hours) || 0,
      end_date: v1.enddate,
      created_by: contract.assigned_name || "—",
      created_at: contract.startdate,
      approved_by: v1.signed_name,
      approved_at: v1.signed_at,
      details: {
        payment_schedule: v1.payment_schedule,
        scope_items: parseScope(v1.project_scope),
      },
      changes: [],
    });
  } else {
    // Contract hasn't been signed/locked yet — no version row exists
    list.push({
      id: "v1",
      version_label: "Version 1",
      title: "Original contract",
      status: contract.is_locked ? "original" : "draft",
      value: parseFloat(contract.value) || 0,
      hours: parseFloat(contract.hours) || 0,
      end_date: contract.enddate,
      created_by: contract.assigned_name || "—",
      created_at: contract.startdate,
      approved_by: null,
      approved_at: null,
      details: {
        payment_schedule: contract.payment_schedule,
        scope_items: parseScope(contract.project_scope),
      },
      changes: [],
    });
  }

  // Amendments
  amendments.forEach((a, idx) => {
    const baseVersion = versionsByNo[a.previous_version_no] || v1 || contract;
    const baseValue = parseFloat(baseVersion.value) || 0;
    const baseHours = parseFloat(baseVersion.hours) || 0;
    const baseEnd = baseVersion.enddate;

    const feeChange = parseFloat(a.fee_change) || 0;
    const hoursChange = parseFloat(a.hours_change) || 0;

    const isSigned = a.status === "signed" && a.version_snapshot;
    const revisedValue = isSigned
      ? parseFloat(a.version_snapshot.value)
      : a.fee_direction === "add" ? baseValue + feeChange : baseValue - feeChange;
    const revisedHours = isSigned
      ? parseFloat(a.version_snapshot.hours)
      : a.hours_direction === "add" ? baseHours + hoursChange : baseHours - hoursChange;
    const revisedEnd = isSigned ? a.version_snapshot.enddate : a.revised_end_date || baseEnd;

    const scopeItems = parseScopeItems(a.scope_items);
    const scopeAdd = scopeItems.filter((s) => s.type === "add").map((s) => s.description);
    const scopeRemove = scopeItems.filter((s) => s.type === "remove").map((s) => s.description);

    let status = "pending";
    let statusLabel = null;
    if (a.status === "signed") status = "approved";
    else if (a.status === "rejected") status = "rejected";
    else if (a.status === "sent_to_client") { status = "pending"; statusLabel = "Awaiting client signature"; }
    else if (a.status === "pending_approval") { status = "pending"; statusLabel = "Awaiting internal approval"; }

    const changes = [];
    if (feeChange) {
      changes.push({
        type: a.fee_direction === "add" ? "fee_add" : "fee_remove",
        label: `${a.fee_direction === "add" ? "+" : "-"}${sym}${feeChange} fee`,
      });
    }
    if (hoursChange) {
      changes.push({
        type: a.hours_direction === "add" ? "hours_add" : "hours_remove",
        label: `${a.hours_direction === "add" ? "+" : "-"}${hoursChange} hrs`,
      });
    }
    if (a.revised_end_date) {
      changes.push({ type: "date", label: `Deadline → ${moment(a.revised_end_date).format("DD MMM YYYY")}` });
    }
    scopeAdd.forEach((s) => changes.push({ type: "scope_add", label: `${s} added` }));
    scopeRemove.forEach((s) => changes.push({ type: "scope_remove", label: `${s} removed` }));

    list.push({
      id: `a${a.id}`,
      version_label: `Amendment ${idx + 1}`,
      title: a.change_reason || a.amendment_no,
      status,
      statusLabel,
      value: revisedValue,
      hours: revisedHours,
      end_date: revisedEnd,
      created_by: a.created_by_name || `User #${a.created_by}`,
      created_at: a.created_at,
      approved_by: a.status === "signed" ? a.signed_name : null,
      approved_at: a.status === "signed" ? a.signed_at : null,
      rejected_by: a.status === "rejected" ? (a.rejected_by_name || `User #${a.internal_rejected_by}`) : null,
      rejected_at: a.status === "rejected" ? a.internal_rejected_at : null,
      description: a.description,
      junk_link: a.junk_link,
      details: {
        effective_date: a.effective_date ? moment(a.effective_date).format("DD MMM YYYY") : "—",
        scope_additions: scopeAdd,
        scope_removals: scopeRemove,
        milestone_changes: a.revised_end_date
          ? [`Deadline → ${moment(a.revised_end_date).format("DD MMM YYYY")}`]
          : [],
        document_sent: a.sent_to_client_at ? moment(a.sent_to_client_at).format("DD MMM YYYY") : "—",
      },
      changes,
    });
  });

  return list;
};

const buildAuditTrail = (rows) =>
  rows.map((r) => {
    const desc = (r.description || "").toLowerCase();
    let dot = "primary";
    if (desc.includes("rejected")) dot = "danger";
    else if (desc.includes("signed") || desc.includes("approved")) dot = "success";
    else if (desc.includes("pending") || desc.includes("sent")) dot = "pending";

    return {
      id: r.id,
      action: r.description,
      actor: r.actor_name || "System",
      timestamp: r.created_at || r.createdAt,
      dot,
    };
  });

const ContractAmendmentHistory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("versions");
  const [expanded, setExpanded] = useState({});
  const [contractData, setContractData] = useState(null);
  const [versions, setVersions] = useState([]);
  const [auditTrail, setAuditTrail] = useState([]);

  document.title = "Amendment History | Zithas CRM";

  useEffect(() => {
    fetchAmendments();
  }, [id]);

  const fetchAmendments = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${configure.nodeApi}/contract_amendment/${id}`);
      if (res?.data?.success) {
        const { contract, versions: rawVersions, amendments, audit_trail } = res.data.data;
        const sym = contract?.currency_symbol || "£";

        setContractData({
          id: contract.id,
          company_name: contract.company_name || "—",
          type: contract.service || "—",
          original_value: rawVersions?.[0]?.value ?? contract.value,
          live_value: contract.value,
          currency_symbol: sym,
          original_hours: rawVersions?.[0]?.hours ?? contract.hours,
          live_hours: contract.hours,
          original_end_date: rawVersions?.[0]?.enddate ?? contract.enddate,
          live_end_date: contract.enddate,
          assigned_name: contract.assigned_name,
          startdate: contract.startdate,
        });

        setVersions(buildVersionsList(contract, rawVersions || [], amendments || [], sym));
        setAuditTrail(buildAuditTrail(audit_trail || []));
      } else {
        Swal.fire({ icon: "error", text: res?.data?.message || "Failed to load amendment history" });
      }
    } catch (err) {
      console.error("Amendment history fetch error:", err);
      Swal.fire({ icon: "error", text: "Failed to load amendment history" });
    } finally {
      setLoading(false);
    }
  };

  const toggleExpand = (versionId) =>
    setExpanded((prev) => ({ ...prev, [versionId]: !prev[versionId] }));

const onOpenSignLink = (version) => {
  if (!version.junk_link) {
    Swal.fire({ icon: "info", text: "This amendment hasn't been sent to the client yet." });
    return;
  }
  window.open(`/sales/contract-amendment-sign/${encodeURIComponent(version.junk_link)}`, "_blank");
};

const onViewAmendment = (version) => {
  if (version.id === "v1") {
    Swal.fire({ icon: "info", text: "Original signed document viewing coming soon." });
    return;
  }
  const amendmentId = version.id.replace(/^a/, "");
  window.open(`/sales/contract-amendment-view/${amendmentId}`, "_blank");
};

const onEditAmendment = (version) => {
  const amendmentId = version.id.replace(/^a/, "");
  navigate(`${configure.appUrl}sales/contract-amendment/edit/${amendmentId}`);
};

const onDeleteAmendment = async (version) => {
  const amendmentId = version.id.replace(/^a/, "");
  Swal.fire({
    title: "Are you sure?",
    text: "You want to delete this amendment?",
    icon: "warning",
    showCancelButton: true,
  }).then(async (result) => {
    if (!result.isConfirmed) return;
    try {
      setLoading(true);
      const res = await axios.delete(
        `${configure.nodeApi}/contract_amendment/delete/${amendmentId}`,
        { data: { user_id: localStorage.getItem("auth_id") } }
      );
      if (res?.data?.success) {
        Swal.fire({ icon: "success", text: "Amendment deleted.", timer: 1500, showConfirmButton: false });
        fetchAmendments(); // refresh
      } else {
        Swal.fire({ icon: "error", text: res?.data?.message || "Could not delete amendment." });
      }
    } catch (err) {
      Swal.fire({ icon: "error", text: err?.response?.data?.message || "Something went wrong." });
    } finally {
      setLoading(false);
    }
  });
};

  const onViewVersion = (version) => {
  if (version.id === "v1") {
    Swal.fire({ icon: "info", text: "Original signed document viewing coming soon." });
    return;
  }
  const amendmentId = version.id.replace(/^a/, ""); // your id is `a${a.id}` in buildVersionsList
  window.open(`/sales/contract-amendment-view/${amendmentId}`, "_blank");
};

  const sym = contractData?.currency_symbol || "£";

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Sales" breadcrumbItem="Amendment History" />

          {contractData && (
            <>
              <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
                <div>
                  <h5 className="mb-1 d-flex align-items-center gap-2">
                    <i className="fas fa-history text-purple"></i>
                    {contractData.company_name} — Amendment history
                  </h5>
                  <span style={{ fontSize: "12px", color: "#74788d" }}>
                    Contract #{contractData.id} · {contractData.type}
                  </span>
                </div>
                <button className="btn btn-danger btn-label" onClick={() => navigate(-1)}>
                  <i className="dripicons-arrow-thin-left label-icon icon-center"></i>
                  Cancel
                </button>
              </div>

              <Card>
                <CardBody className="p-0">
                  <div className="d-flex border-bottom" style={{ padding: "0 16px" }}>
                    <TabButton active={activeTab === "versions"} onClick={() => setActiveTab("versions")} icon="fas fa-layer-group">
                      All versions
                    </TabButton>
                    <TabButton active={activeTab === "audit"} onClick={() => setActiveTab("audit")} icon="fas fa-list-ul">
                      Audit trail
                    </TabButton>
                  </div>

                  <div className="p-3">
                    {activeTab === "versions" && (
                      <div>
                        {versions.map((version) => {
                          const cfg = STATUS_CONFIG[version.status] || STATUS_CONFIG.draft;
                          const isOpen = expanded[version.id];

                          return (
                            <div
                              key={version.id}
                              className="mb-4 rounded"
                              style={{
                                border: "1px solid #d6dbe3",
                                borderLeft: "1px solid #d6dbe3",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                overflow: "hidden",
                                background: "#fff",
                              }}
                            >
                              <div
                                className="d-flex align-items-center justify-content-between px-3 py-2"
                                style={{ background: "#f8f9fa", borderBottom: "1px solid #eff2f7" }}
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <span
                                    className="badge me-2"
                                    style={{ fontSize: "10px", padding: "5px 8px", background: "#6a2a8d" }}
                                  >
                                    {version.version_label}
                                  </span>
                                  {version.title}
                                </div>
                               
                                {/* <div className="d-flex align-items-center gap-2">
  <Badge className={cfg.className} style={{ fontSize: "11px" }}>
    {version.statusLabel || cfg.label}
  </Badge>

  {version.id !== "v1" && (
    <button
      className="btn btn-sm btn-outline-secondary"
      style={{ fontSize: "11px", padding: "3px 10px" }}
      onClick={() => onViewAmendment(version)}
      title="View amendment document"
    >
      <i className="fas fa-eye me-1"></i> View
    </button>
  )}

  {version.id !== "v1" && version.junk_link && (
    <button
      className="btn btn-sm btn-outline-primary"
      style={{ fontSize: "11px", padding: "3px 10px" }}
      onClick={() => onOpenSignLink(version)}
      title="Open client signing link"
    >
      <i className="fas fa-file-signature me-1"></i> Sign Link
    </button>
  )}
</div> */}

<div className="d-flex align-items-center gap-2">
  <Badge className={cfg.className} style={{ fontSize: "11px" }}>
    {version.statusLabel || cfg.label}
  </Badge>

  {/* VIEW — all non-v1 versions */}
  {version.id !== "v1" && (
    <button
      className="btn btn-sm btn-outline-secondary"
      style={{ fontSize: "11px", padding: "3px 10px" }}
      onClick={() => onViewAmendment(version)}
      title="View amendment document"
    >
      <i className="fas fa-eye me-1"></i> View
    </button>
  )}

  {/* SIGN LINK — only if has junk_link */}
  {version.id !== "v1" && version.junk_link && (
    <button
      className="btn btn-sm btn-outline-primary"
      style={{ fontSize: "11px", padding: "3px 10px" }}
      onClick={() => onOpenSignLink(version)}
      title="Open client signing link"
    >
      <i className="fas fa-file-signature me-1"></i> Sign Link
    </button>
  )}

  {/* EDIT — latest amendment only, not signed/rejected */}
  {version.id !== "v1" &&
    version.status !== "approved" &&
    version.status !== "rejected" &&
    versions[versions.length - 1]?.id === version.id && (
    <button
      className="btn btn-sm btn-outline-warning"
      style={{ fontSize: "11px", padding: "3px 10px" }}
      onClick={() => onEditAmendment(version)}
      title="Edit amendment"
    >
      <i className="fas fa-pencil-alt me-1"></i> Edit
    </button>
  )}

  {/* DELETE — latest amendment only, not signed */}
  {version.id !== "v1" &&
    version.status !== "approved" &&
    versions[versions.length - 1]?.id === version.id && (
    <button
      className="btn btn-sm btn-outline-danger"
      style={{ fontSize: "11px", padding: "3px 10px" }}
      onClick={() => onDeleteAmendment(version)}
      title="Delete amendment"
    >
      <i className="fas fa-trash-alt me-1"></i> Delete
    </button>
  )}
</div>
                              </div>

                              <div className="p-3">
                                {version.changes?.length > 0 && (
                                  <div className="d-flex flex-wrap gap-1 mb-3">
                                    {version.changes.map((ch, i) => {
                                      const chip = CHANGE_CHIP[ch.type] || CHANGE_CHIP.date;
                                      return (
                                        <span
                                          key={i}
                                          className="d-inline-flex align-items-center gap-1"
                                          style={{
                                            background: chip.bg,
                                            color: chip.color,
                                            fontSize: "11px",
                                            padding: "3px 10px",
                                            borderRadius: "50px",
                                            fontWeight: 500,
                                          }}
                                        >
                                          <i className={chip.icon} style={{ fontSize: "10px" }}></i>
                                          {ch.label}
                                        </span>
                                      );
                                    })}
                                  </div>
                                )}

                                <div className="d-flex flex-wrap gap-3 mb-2" style={{ fontSize: "13px" }}>
                                  <KVPair label="Value" value={`${sym}${(version.value || 0).toLocaleString()}`} />
                                  <KVPair label="Hours" value={`${version.hours || 0} hrs`} />
                                  <KVPair
                                    label="Completion"
                                    value={version.end_date ? moment(version.end_date).format("DD MMM YYYY") : "—"}
                                  />
                                </div>

                                {version.description && (
                                  <div
                                    className="mb-2 p-2 rounded"
                                    style={{ background: "#f8f9fa", fontSize: "12px", color: "#74788d", borderLeft: "3px solid #eff2f7" }}
                                    dangerouslySetInnerHTML={{ __html: version.description }}
                                  />
                                )}

                                <div
                                  className="d-flex align-items-center justify-content-between flex-wrap gap-2 pt-2"
                                  style={{ borderTop: "1px solid #eff2f7", fontSize: "11px", color: "#74788d" }}
                                >
                                  <span>
                                    <i className="fas fa-user-edit me-1"></i>
                                    Created by <strong>{version.created_by}</strong> ·{" "}
                                    {version.created_at ? moment(version.created_at).format("DD MMM YYYY") : "—"}
                                  </span>
                                  {version.approved_by && (
                                    <span>
                                      <span style={{ color: "#34c38f" }}>
                                        <i className="fas fa-check-circle me-1"></i>Approved
                                      </span>{" "}
                                      by <strong>{version.approved_by}</strong> ·{" "}
                                      {moment(version.approved_at).format("DD MMM YYYY")}
                                    </span>
                                  )}
                                  {version.rejected_by && (
                                    <span>
                                      <span style={{ color: "#f46a6a" }}>
                                        <i className="fas fa-times-circle me-1"></i>Rejected
                                      </span>{" "}
                                      by <strong>{version.rejected_by}</strong> ·{" "}
                                      {moment(version.rejected_at).format("DD MMM YYYY")}
                                    </span>
                                  )}
                                  {version.status === "pending" && (
                                    <span style={{ color: "#f1b44c" }}>
                                      <i className="fas fa-clock me-1"></i>
                                      {version.statusLabel || "Pending"}
                                    </span>
                                  )}
                                  <button
                                    className="btn btn-link p-0 text-decoration-none"
                                    style={{ fontSize: "11px", color: "#556ee6" }}
                                    onClick={() => toggleExpand(version.id)}
                                  >
                                    <i className={`fas ${isOpen ? "fa-chevron-up" : "fa-chevron-down"} me-1`}></i>
                                    {isOpen ? "Hide details" : "Show details"}
                                  </button>
                                </div>

                                {isOpen && (
                                  <div
                                    className="mt-2 p-3 rounded"
                                    style={{ background: "#f8f9fa", border: "1px solid #eff2f7", fontSize: "12px" }}
                                  >
                                    <DetailGrid details={version.details} />
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {activeTab === "audit" && (
                      <div style={{ position: "relative", paddingLeft: "28px" }}>
                        <div
                          style={{
                            position: "absolute",
                            left: "9px",
                            top: "6px",
                            bottom: "6px",
                            width: "1px",
                            background: "#eff2f7",
                          }}
                        />
                        {auditTrail.length === 0 && (
                          <p className="text-muted" style={{ fontSize: "13px" }}>No activity recorded yet.</p>
                        )}
                        {auditTrail.map((item) => (
                          <div key={item.id} className="mb-3" style={{ position: "relative" }}>
                            <div
                              style={{
                                position: "absolute",
                                left: "-22px",
                                top: "4px",
                                width: "11px",
                                height: "11px",
                                borderRadius: "50%",
                                background: DOT_COLORS[item.dot] || "#eff2f7",
                                border: `2px solid ${DOT_COLORS[item.dot] || "#ced4da"}`,
                              }}
                            />
                            <div style={{ fontSize: "13px" }}>
                              <span style={{ fontWeight: 500, color: "#495057" }}>{item.action}</span>
                              <div style={{ fontSize: "11px", color: "#74788d", marginTop: "2px" }}>
                                <i className="fas fa-user me-1"></i>
                                {item.actor}
                                <span className="mx-2">·</span>
                                <i className="fas fa-clock me-1"></i>
                                {item.timestamp ? moment(item.timestamp).format("DD MMM YYYY · hh:mm A") : "—"}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

/* ── Sub-components ── */

const TabButton = ({ active, onClick, icon, children }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      background: "none",
      border: "none",
      borderBottom: active ? "2px solid #556ee6" : "2px solid transparent",
      color: active ? "#556ee6" : "#74788d",
      fontWeight: active ? 500 : 400,
      fontSize: "13px",
      padding: "12px 16px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      marginBottom: "-1px",
    }}
  >
    <i className={icon} style={{ fontSize: "13px" }}></i>
    {children}
  </button>
);

const KVPair = ({ label, value }) => (
  <span style={{ fontSize: "13px" }}>
    <span style={{ color: "#74788d", marginRight: "4px" }}>{label}:</span>
    <strong style={{ color: "#343a40" }}>{value}</strong>
  </span>
);

const DetailGrid = ({ details }) => {
  if (!details) return null;
  return (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
      <tbody>
        {Object.entries(details).map(([key, val]) => {
          const label = key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
          const display = Array.isArray(val) ? (val.length ? val.join(", ") : "None") : val || "—";
          return (
            <tr key={key}>
              <td style={{ padding: "4px 8px 4px 0", color: "#74788d", width: "160px", verticalAlign: "top", fontWeight: 500 }}>
                {label}
              </td>
              <td style={{ padding: "4px 0", color: "#495057" }}>{display}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ContractAmendmentHistory;